export default async function loadHtmlModalFunc() {
    const { default: HtmlModal } = await import(/* webpackChunkName: "htmlModal" */ 'modules/modal/htmlModal');
    return HtmlModal;
}
